import { createContext, useCallback, useContext, useEffect, useState } from 'react';
const ContentContext = createContext({articles: [], cities: [], reload: () => {}});
export const PublicContentProvider = ({children}) => {
  const [content, setContent] = useState({articles: [], cities: []});
  const reload = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/navigation`, {cache: 'no-store'});
      if (response.ok) setContent(await response.json());
    } catch { /* Navigation retains its last known published-only snapshot during an outage. */ }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentContext.Provider value={{...content, reload}}>{children}</ContentContext.Provider>;
};
export const usePublicContent = () => useContext(ContentContext);